import {useMemo} from "react";
import {useGetAudiences} from "../../apis/requests/audiences/getAudiences";

export const usePopulatedSegmentIds = (): Set<number> | undefined => {
  const {data: audiences} = useGetAudiences();
  return useMemo(
    () =>
      audiences &&
      new Set(
        audiences.filter((audience) => audience.account_count > 0).flatMap((audience) => audience.audience_segment_ids)
      ),
    [audiences]
  );
};

type BucketLike = {id: number; segment_category: string | null; is_category_fallback: boolean};

export const isEmptyBucket = (segment: BucketLike, populatedSegmentIds: Set<number> | undefined) =>
  segment.segment_category !== null && populatedSegmentIds !== undefined && !populatedSegmentIds.has(segment.id);

export const isEmptyCategoryFallback = (segment: BucketLike, populatedSegmentIds: Set<number> | undefined) =>
  segment.is_category_fallback && isEmptyBucket(segment, populatedSegmentIds);
